import {
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';

// An on or off switch for a plain yes/no setting: a pill track with a thumb, its label on the left
@Component({
  selector   : 'wor-toggle-switch',
  styles: [ require('./toggle-switch.component.scss') ],
  template: require('./toggle-switch.component.html')
})
export class ToggleSwitchComponent {
  @Input() isChecked  : boolean = false;
  @Input() isDisabled : boolean = false;
  @Input() label      : string  = '';

  @Output() isCheckedChange : EventEmitter<boolean> = new EventEmitter<boolean>();

  toggle () : void {
    if ( this.isDisabled ) {
      return;
    }

    this.isChecked = !this.isChecked;

    this.isCheckedChange.emit(this.isChecked);
  }
}
